"use strict";

// polyfill
if (!Array.prototype.findLast) {
    Array.prototype.findLast = function (callback) {
        if (this == null) {
            throw new TypeError('this is null or not defined');
        }
        const arr = Object(this);
        const len = arr.length >>> 0;
        for (let i = len - 1; i >= 0; i--) {
            if (callback(arr[i], i, arr)) {
                return arr[i];
            }
        }
        return undefined;
    };
}

var ACC;
ACC.gtmToGa = {
  productImpressions: [],
  initiallyMissedGaContainers: [],
  gaGlobalJsonMissedContainers: [],
  // convert gtmContainers to gaContainers
  convertAndPushGlobalContainer: function (gtmGlobalContainer) {
    if (ACC.ga) {
      ACC.ga.convertAndPushGlobalContainer(gtmGlobalContainer);
    } else if (typeof (dataLayer) != 'undefined') {
      if (ACC.gtmToGa) {
        ACC.gtmToGa.initiallyMissedGaContainers.push(gtmGlobalContainer);
      }
    }
  },
  // directly push server gaContainers
  pushGaGlobalContainer: function (gaServerContainer) {
    var gaGlobalContainer = gaServerContainer || {};
    ACC.gtmToGa.setGaDetailsToServerContainer(gaGlobalContainer);

    if (ACC.ga) {
      ACC.ga.dispatchDataEvents(gaGlobalContainer);
    } else if (typeof (dataLayer) != 'undefined') {
      ACC.gtmToGa.gaGlobalJsonMissedContainers.push(gaGlobalContainer);
    }
    return gaGlobalContainer;
  },
  getItemPosition: function (itemsArray) {
    var presentationItemPosition = window.localStorage.getItem("ITEM_POSITION_TRACK_KEY");
    var itemPosition = null;

    if (presentationItemPosition) {
      var positionsList = JSON.parse(presentationItemPosition);

      if (itemsArray.length === 1) {
        var positionListItem = positionsList.filter(function (el) {
          return itemsArray[0]['item_id'] === el.id;
        }).slice(-1)[0];
        itemPosition = positionListItem ? positionListItem.position : null;
      } else {
        var foundsItems = [];
        itemsArray.forEach(function (el) {
          var i = positionsList.filter(e => el.item_id === e.id);
          foundsItems = foundsItems.concat(i);
        });
        if (foundsItems.length > 0) {
          var foundPositionItem = positionsList.filter(function (el) {
            return foundsItems[0].bundleId === el.bundleId
          }).slice(-1)[0];
          itemPosition = foundPositionItem ? foundPositionItem.position : null;
        }
      }
    }

    return itemPosition;
  },
  setGaDetailsToServerContainer: function (gaGlobalContainer) {
    var event = gaGlobalContainer['event'];
    var itemsArray = gaGlobalContainer['items'] || [];
    const storedProducts = JSON.parse(localStorage.getItem('itemsListAttrBasketAdd') || '[]');

    if (event === 'view_item' || event === 'view_item_list') {
      var searchTerm = localStorage.getItem('searchTerm');
      var searchCategorySuggestion = localStorage.getItem('searchCategorySuggestion');
      var isSelectedFromQB = localStorage.getItem('isSelectedFromQB') ? localStorage.getItem('isSelectedFromQB') : 'No';
      var itemPosition = ACC.gtmToGa.getItemPosition(itemsArray);
      const storedItemData = localStorage.getItem('itemsListAttr');
      const itemData = storedItemData ? JSON.parse(storedItemData) : {};
      const itemListName = itemData.item_list_name;
      const itemListId = itemData.item_list_id;

      itemsArray.forEach(function (item) {
        item['dimension82'] = searchTerm;
        item['dimension83'] = searchCategorySuggestion;

        if (event === 'view_item') {
          item['index'] = itemPosition;
          item['item_list_name'] = itemListName;
          item['item_list_id'] = itemListId;

          if (window.localStorage.getItem(window.ACC.selectedFromQB)) {
            var selectedProductId = window.localStorage.getItem(window.ACC.selectedFromQB);
            if (item.id === selectedProductId) {
              isSelectedFromQB = 'Yes';
            }
          }
          item['dimension95'] = isSelectedFromQB
        }
      });
    }

    if (event === 'begin_checkout') {
        itemsArray.forEach(function (item) {
            const cartProduct = storedProducts.find(storedItem => storedItem.productCode === item.dimension4 && storedItem.size === item.item_variant);

            if (cartProduct) {
                item['item_list_name'] = cartProduct.item_list_name;
                item['item_list_id'] = cartProduct.item_list_id;
            }
        });
    }
    if (event === 'purchase_confirmed') {
      var gtmGlobal = ACC.gtm.gtmGlobal;
      var gtmGlobalProducts = gtmGlobal['ecommerce']['purchase']['products'];
      const storedPromoDetails = JSON.parse(localStorage.getItem('promoProductDetails') || '[]');

      itemsArray.forEach(function (item, key) {
        if (gtmGlobalProducts[key]) {
          item['dimension82'] = gtmGlobalProducts[key]['dimension82'];
          item['dimension83'] = gtmGlobalProducts[key]['dimension83'];
          item['dimension95'] = gtmGlobalProducts[key]['dimension95'];
          item['index'] = gtmGlobalProducts[key]['position'];
        }

        const cartProduct = storedProducts.find(storedItem => storedItem.productCode === item.dimension4 && storedItem.size === item.item_variant);
        const promoProduct = storedPromoDetails.find(storedPromo => storedPromo.productCode === item.dimension4 && storedPromo.size === item.item_variant);

        if (cartProduct) {
            item['item_list_name'] = cartProduct.item_list_name;
            item['item_list_id'] = cartProduct.item_list_id;
        }

        if(promoProduct) {
          item['internal_promo_name'] = promoProduct.promoName ?? null;
          item['internal_promo_id'] = promoProduct.promoId ?? null;
        }
      });

      localStorage.removeItem('itemsListAttrBasketAdd');
      localStorage.removeItem('promoProductDetails');
      localStorage.removeItem('promotionAttrs');
    }

    // Update GA email address and phone number with data from GTM global object in localStorage
    // GTM global object has correct BE data for CAPI
    const gtmGlobalLocalStorage = localStorage.getItem('gtm.global');
    if (gtmGlobalLocalStorage) {

      // use gtm.global from localStorage to update the GA Data object
      const gtmGlobal = JSON.parse(gtmGlobalLocalStorage);
    
      // email_address from gtm.global in localStorage
      if (gtmGlobal?.email_address) {
        gaGlobalContainer['email_address'] = gtmGlobal.email_address;
      } else {
        // ensure the field is null if there is no email address as per CAPI requirements
        gaGlobalContainer['email_address'] = null;
      }
    
      // phone number from gtm.global in localStorage
      if (gtmGlobal?.phone_number) {
        gaGlobalContainer['phone_number'] = gtmGlobal.phone_number;
      } else {
        // ensure the field is null if there is no phone number as per CAPI requirements
        gaGlobalContainer['phone_number'] = null;
      }
    }

    // Update payment method
    gaGlobalContainer['payment_method'] = sessionStorage.getItem('paymentMethod') || sessionStorage.getItem('paymentMethodType')

    // Update the screen size
    gaGlobalContainer['screen_size'] = ACC.gtm.getGtmScreenSize();
  },
  // directly/delay push server gaConainers
  gaPushOrDelayEventData: function (gaServerContainer, componentId, callback) {
    if (gaServerContainer) {
      gaServerContainer.skipGtmLogic = true;
    }
    return ACC.gtm.gtmPushOrDelayEventData(gaServerContainer, componentId, callback, 'ga', true);
  },
  verifySkipGtmTreatments: function (gaServerContainer) {
    if (!gaServerContainer || !gaServerContainer.skipGtmLogic) {
      return false;
    }
    delete gaServerContainer.skipGtmLogic;
    return true;
  },
  // new event bindings
  bindGaAddShippingInfo: function () {
    // Delivery
    $('#tjxAddressForm').off('submit', ACC.gtmToGa.trackAddShippingInfo);
    $('#tjxAddressForm').on('submit', ACC.gtmToGa.trackAddShippingInfo);
    // Click & Collect
    $('#tjxClickCollectForm').off('submit', ACC.gtmToGa.trackAddShippingInfo);
    $('#tjxClickCollectForm').on('submit', ACC.gtmToGa.trackAddShippingInfo);
    // Parcel Shop
    $('#tjxCollectionPointForm').off('submit', ACC.gtmToGa.trackAddShippingInfo);
    $('#tjxCollectionPointForm').on('submit', ACC.gtmToGa.trackAddShippingInfo);
  },
  bindGaAddPaymentInfo: function () {
    $('#creditPayButton').off('click', ACC.gtmToGa.trackAddPaymentInfo);
    $('#creditPayButton').on('click', ACC.gtmToGa.trackAddPaymentInfo);
    $(document).off('click', '#apple-pay-button', ACC.gtmToGa.trackAddPaymentInfo);
    $(document).on('click', '#apple-pay-button', ACC.gtmToGa.trackAddPaymentInfo);
  },
  // new event treatments
  trackAddShippingInfo: function (e) {
    const gtmLastCheckoutOption = dataLayer?.findLast((item) => item.event === 'checkout_option');
    if (gtmLastCheckoutOption) {
      const addShippingInfoContainer = {
        ...gtmLastCheckoutOption,
        event: 'add_shipping_info'
      };
      ACC.gtmToGa.convertAndPushGlobalContainer(addShippingInfoContainer);
    }
  },
  trackAddPaymentInfo: function (paymentType = '') {
    let addPaymentInfoContainer;
    const gtmLastCheckout = dataLayer?.findLast((item) => item.event === 'checkout');
    if (gtmLastCheckout) {
      addPaymentInfoContainer = {
        ...gtmLastCheckout,
        event: 'add_payment_info'
      };
    } else {
      const gtmLastCheckoutOption = dataLayer?.findLast((item) => item.event === 'checkout_option');
      if (gtmLastCheckoutOption) {
        addPaymentInfoContainer = {
          ...gtmLastCheckoutOption,
          event: 'add_payment_info',
        };
      }
    }
    if (addPaymentInfoContainer) {
      if (typeof paymentType === 'string' && paymentType.trim()) {
        addPaymentInfoContainer.paymentType = paymentType.trim();
      }
      ACC.gtmToGa.convertAndPushGlobalContainer(addPaymentInfoContainer);
    }
  },
  collectProductImpressions: function (gaData) {
    var products = [];
    try {
      // We need a deep clone
      products = JSON.stringify(gaData.items.filter(function (product) {
        // Drop any products that do not have "id" and "list" attributes
        return product['item_id'] && product['item_list_name']
      }));
    } catch (error) {
      console.warn("No products found");
    } finally {
      var productImpressions = ACC.gtmToGa.productImpressions;
      ACC.gtmToGa.productImpressions = productImpressions.concat.apply(ACC.gtmToGa.productImpressions, JSON.parse(products));
    }
  },
};
